import { CashDetail } from "./CashDetail";
import { Denomination } from "./Denomination";
import { StockContent } from "./StockContent";
import { CashCountTotals } from "./content/CashCountTotals";
import { CashTypeEnum } from "./enums/CashTypeEnum";
import { StockTypeEnum } from "./enums/StockTypeEnum";

export class CashCount {
    /** Contenuto di ogni magazzino */
    stockContents: StockContent[] = [];

    /** Distinct sulle denominazioni contenute nella macchina */
    denominations: Denomination[] = [];

    /** Distinct sulle valute contenute nella macchina */
    currencies: string[] = [];

    public parse(obj: any) {
        if (obj.StockContents && obj.StockContents.length > 0) {
            obj.StockContents.forEach((e) => {
                let m: StockContent = new StockContent();
                m.parse(e);
                this.stockContents.push(m);
            });
        }
        if (obj.Denominations && obj.Denominations.length > 0) {
            obj.Denominations.forEach((e) => {
                let m: Denomination = new Denomination();
                m.parse(e);
                this.denominations.push(m);
            });
        }
        if (obj.Currencies && obj.Currencies.length > 0) {
            obj.Currencies.forEach((e) => {
                this.currencies.push(e);
            });
        }
    }

    /**
     * Metodo che mi restituisce l'importo totale e la quantità totale di pezzi
     * totali contenturi in un CashCount filtrando per CashType o per valuta.
     * @param type CashType su cui si vuole eventualmente filtrare
     * @param currency Valuta su cui si vuole eventualmente filtrare
     */
    public getTotals(type?: CashTypeEnum, currency?: string): CashCountTotals {
        const result: CashCountTotals = {
            totalAmount: 0,
            totQty: 0,
        };

        // Per ogni magazzino
        this.stockContents.forEach((stockContent: StockContent) => {
            let totalsTemp: CashCountTotals = stockContent.getTotals(type, currency);
            result.totalAmount += totalsTemp.totalAmount;
            result.totQty += totalsTemp.totQty;
        });

        if (currency) {
            result.currency = currency;
        }
        return result;
    }

    /**
     * Metodo che mi restituisce, per tutte le valute, l'importo totale e
     * la quantità totale di un CashCount.
     * @param stockType Tipo di stock su cui si vuole eventualmente filtrare
     */
    public getTotalsByCurrencies(stockType?: StockTypeEnum): CashCountTotals[] {
        let result: CashCountTotals[] = [];

        // Per ogni valuta
        this.currencies
            .filter((c) => c != "XXX")
            .forEach((currency: string) => {
                // Per ogni magazzino
                this.stockContents.forEach((stockContent: StockContent) => {
                    if (!stockType || (stockType && stockContent.stockType == stockType)) {
                        let currentTotal = stockContent.getTotals(undefined, currency);
                        /** Mi restituisce ad esempio
                         * totalAmount = 500
                         * totalQty = 30
                         * currency = CIM
                         */
                        let add: boolean = false;
                        result.forEach((singleTotal: CashCountTotals) => {
                            if (currency == singleTotal.currency) {
                                singleTotal.totQty += currentTotal.totQty;
                                singleTotal.totalAmount += currentTotal.totalAmount;
                                add = true;
                            }
                        });
                        if (!add) result.push(currentTotal);
                    }
                });
            });

        // DEBUG Multivaluta test
        // result.push({ totalAmount: 200, totQty: 10, currency: "EUR" });

        return result;
    }

    /**
     * Metodo che restituisce il numero totale di pezzi in sacca.
     */
    public totalQuantityInBag(): number {
        let result: number = 0;

        // Per ogni magazzino
        this.stockContents.forEach((stockContent: StockContent) => {
            if (stockContent.stockType == StockTypeEnum.Bag) {
                let totalsTemp: CashCountTotals = stockContent.getTotals();
                result += totalsTemp.totQty;
            }
        });

        return result;
    }

    /**
     * Metodo che mi restituisce una lista di cashDetail aggregando
     * il contenuto di ogni magazzino
     */
    public getSummaryCashDetailsList(): CashDetail[] {
        let res: CashDetail[] = [];

        // Per ogni denominazione
        this.denominations.forEach((denomination: Denomination) => {
            let cashDetailTemp: CashDetail = new CashDetail();
            cashDetailTemp.denomination = denomination;
            cashDetailTemp.quantity = 0;
            res.push(cashDetailTemp);
        });

        // Per ogni magazzino
        this.stockContents.forEach((stockContent: StockContent) => {
            stockContent.content.forEach((cashDetailStock: CashDetail) => {
                res.forEach((cashDetailRes) => {
                    if (cashDetailRes.denomination.isEquals(cashDetailStock.denomination)) {
                        cashDetailRes.quantity += cashDetailStock.quantity;
                    }
                });
            });
        });

        CashDetail.sort(res);

        return res;
    }
}
